// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .schedules {
  background-color: #f6f3f3;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.theme-light .schedules .scheduleForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #000;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.theme-light .schedules .scheduleForm .formGroup {
  margin: 5px;
}
.theme-light .schedules .scheduleForm .formGroup label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}
.theme-light .schedules .scheduleForm .formGroup input {
  width: 100%;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: white;
  color: #000;
}
.theme-light .schedules .scheduleForm .formGroup select {
  width: 100%;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: white;
  color: #000;
}
.theme-light .schedules .scheduleForm #metadata {
  min-width: 400px;
  min-height: 300px;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: white;
  color: #000;
}
.theme-light .schedules .scheduleForm .submitButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: blue;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.theme-light .schedules .scheduleForm .resetButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: red;
  color: white;
  cursor: pointer;
  margin-right: 10px;
}
.theme-dark .schedules {
  background-color: #333;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.theme-dark .schedules .scheduleForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #222;
  color: #fffef9;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.theme-dark .schedules .scheduleForm .formGroup {
  margin: 5px;
}
.theme-dark .schedules .scheduleForm .formGroup label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}
.theme-dark .schedules .scheduleForm .formGroup input {
  width: 100%;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .schedules .scheduleForm .formGroup select {
  width: 100%;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .schedules .scheduleForm #metadata {
  min-width: 400px;
  min-height: 300px;
  padding: 10px;
  border: 1px solid;
  border-radius: 4px;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .schedules .scheduleForm .submitButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: blue;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.theme-dark .schedules .scheduleForm .resetButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: red;
  color: white;
  cursor: pointer;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/schedules/schedules.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAFN;AAIM;EACE,WAAA;AAFR;AAIQ;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAFV;AAKQ;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAHV;AAMQ;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAJV;AAQM;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AANR;AAUM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AARR;AAeM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAbR;ADnDI;ECjBA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAuEJ;AArEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAuEN;AArEM;EACE,WAAA;AAuER;AArEQ;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAuEV;AApEQ;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAsEV;AAnEQ;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAqEV;AAjEM;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAmER;AA/DM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAiER;AA1DM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA4DR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.schedules {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    \n    .scheduleForm {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      background-color: themed(\"bg\");\n      color: themed(\"textColor\");\n      padding: 20px;\n      border-radius: 4px;\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n      width: 100%;\n      max-width: 600px;\n      margin: 0 auto;\n      margin-bottom: 20px;\n  \n      .formGroup {\n        margin: 5px;\n      \n        label {\n          display: block;\n          font-weight: 500;\n          margin-bottom: 5px;\n        }\n  \n        input {\n          width: 100%;\n          padding: 10px;\n          border: 1px solid themed(\"borderColor\");\n          border-radius: 4px;\n          background-color: themed(\"bg\");\n          color: themed(\"textColor\");\n        }\n  \n        select {\n          width: 100%;\n          padding: 10px;\n          border: 1px solid themed(\"borderColor\");\n          border-radius: 4px;\n          background-color: themed(\"bg\");\n          color: themed(\"textColor\");\n        }\n      }\n  \n      #metadata { // textarea\n        min-width: 400px;\n        min-height: 300px;\n        padding: 10px;\n        border: 1px solid themed(\"borderColor\");\n        border-radius: 4px;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        // resize: ;\n      }\n  \n      .submitButton {\n        padding: 10px 20px;\n        border: none;\n        border-radius: 4px;\n        background-color: blue;\n        color: white;\n        cursor: pointer;\n        transition: background-color 0.3s;\n  \n        &:hover {\n          background-color: themed(\"primary\");\n        }\n      }\n  \n      .resetButton {\n        padding: 10px 20px;\n        border: none;\n        border-radius: 4px;\n        background-color: red;\n        color: white;\n        cursor: pointer;\n        margin-right: 10px;\n  \n        &:hover {\n          background-color: themed(\"danger\");\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
